import fx from "utils/fx";
import AxiosInterceptor from "api/interceptor";

const award = new AxiosInterceptor();

export default {
  get(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return award.get("/awards?" + qstr);
  },
  find(id) {
    return award.get("/awards/" + id);
  },
  create(data) {
    return award.post("/awards", data);
  },
  update(id, data) {
    return award.put("/awards/" + id, data);
  },
  delete(id) {
    return award.delete("/awards/" + id);
  },
};
